import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy/marketing alias for the command center. */
export const Route = createFileRoute("/acquisition")({
  beforeLoad: () => {
    throw redirect({ to: "/" });
  },
});
